module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r1r3r6n-b3786a3b56d3f61b6d1239010f33c3ce.svg";